import { Reducer } from 'redux';
import { ACTION_TYPES, State } from './../types';

export const initialState: State = {
  admins: [],
  clubs: {
    pending: false,
    items: [],
    error: '',
  },
};

const reducer: Reducer<State, any> = (state = initialState, action): any => {
  const map: any = {
    [ACTION_TYPES.CLEAR]: () => ({
      ...initialState,
    }),

    [ACTION_TYPES.SET_STRATEGY]: () => {
      return {
        ...state,
        strategy: action.payload,
      };
    },

    [ACTION_TYPES.STORE_ADMINS]: () => ({
      ...state,
      admins: action.payload,
    }),

    [ACTION_TYPES.ADD_ADMIN]: () => ({
      ...state,
      admins: [...state.admins, action.payload],
    }),

    [ACTION_TYPES.FETCH_CLUBS_PENDING]: () => ({
      ...state,
      clubs: {
        ...state.clubs,
        pending: true,
      },
    }),

    [ACTION_TYPES.FETCH_CLUBS_FETCHED]: () => ({
      ...state,
      clubs: {
        ...state.clubs,
        pending: false,
        items: action.payload,
      },
    }),

    [ACTION_TYPES.FETCH_CLUBS_ERROR]: () => ({
      ...state,
      clubs: {
        ...state.clubs,
        pending: false,
        error: action.payload,
      },
    }),
  };

  return typeof map[action.type] === 'function' ? map[action.type]() : state;
};

export default reducer;
